import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html"
    }}>{`html`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Indicates the root element of an UXP plugin's UI.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/html"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/html`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<html>
    <head>
    </head>
    <body>
        Hello, world
    </body>
</html>
`}</code></pre>
    <h2 {...{
      "id": "attributes"
    }}>{`Attributes`}</h2>
    <p>{`The following attributes are not supported, and have no effect:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`manifest`}</inlineCode>{` `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`version`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`xmlns`}</inlineCode></li>
    </ul>
    <p>{`The following attributes are supported:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`lang`}</inlineCode>{` – can be used to specify the language of the document.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      